module.exports = __webpack_public_path__ + "img/clientss.89eee8fa.svg";